import { Box, Button, Divider, Modal } from "@mui/material";
import React from "react";
import WarningModal from "./WarningModal";
import EditInventory from "scenes/EditInventory";
import { useNavigate } from "react-router-dom";

const styles = {
  button:
    "text-white px-6 py-2 focus:outline-none rounded cursor-pointer w-[100px] my-2",
};

const StatusChangeButtons = ({ data }) => {
  const navigate = useNavigate();
  const [carStatus, setCarStatus] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      {/* Divider Line */}
      <Divider className="my-6" />
      {/* Display all the action buttons in grid like sell ,archive, unarchive, approve, reject */}
      <div className="grid grid-cols-4 grid-flow-row place-items-center gap-2">
        {/* <Button
            variant="outlined"
          className={`${styles.button} bg-slate-500 hover:bg-slate-700`}
        >
          Edit
        </Button> */}
        <EditInventory data={data} />
        <Button
          variant="secondary"
          className={`${styles.button} bg-red-500 hover:bg-red-700`}
          onClick={() => {
            setCarStatus("Deleted");
            handleOpenModal();
          }}
        >
          Delete
        </Button>
        {data.status === "Pending Approval" ? (
          <>
            <Button
              className={`${styles.button} bg-emerald-500 hover:bg-emerald-700`}
              onClick={() => {
                setCarStatus("Available");
                handleOpenModal();
              }}
            >
              Approve
            </Button>
            <Button
              className={`${styles.button} bg-red-500 hover:bg-red-700`}
              onClick={() => {
                setCarStatus("Rejected");
                handleOpenModal();
              }}
            >
              Reject
            </Button>
          </>
        ) : (
          <></>
        )}

        {data.status === "Available" ? (
          <>
            <Button
              onClick={() => {
                // setCarStatus("Booked");
                // handleOpenModal();
                // redirect to initate transaction page with car id
                navigate(`/transaction-initiate?id=${data._id}`);
              }}
              className={`${styles.button} bg-teal-500 hover:bg-teal-600`}
            >
              Sell
            </Button>
            <Button
              onClick={() => {
                setCarStatus("Archived");
                handleOpenModal();
              }}
              className={`${styles.button} bg-amber-500 hover:bg-amber-600`}
            >
              Archive
            </Button>
          </>
        ) : (
          <></>
        )}

        {data.status === "Archived" ? (
          <Button
            onClick={() => {
              setCarStatus("Available");
              handleOpenModal();
            }}
            className={`${styles.button} bg-cyan-500 hover:bg-cyan-700`}
          >
            Unarchive
          </Button>
        ) : (
          <></>
        )}
      </div>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box>
          <WarningModal
            handleCloseModal={handleCloseModal}
            data={data}
            status={carStatus}
          />
        </Box>
      </Modal>
    </>
  );
};

export default StatusChangeButtons;
